// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from 'app/core/_base/crud';
import { DeNghiChuyenKhoService } from '../de-nghi-chuyen-kho-service/de-nghi-chuyen-kho.service';
//Models

import { DeNghiChuyenKhoModel } from '../de-nghi-chuyen-kho-model/de-nghi-chuyen-kho.model';

import { DeNghiChuyenKhoCTModel,CtHangTonModel,HistoryHHNhapKho } from '../de-nghi-chuyen-kho-model/de-nghi-chuyen-kho.model';

import { DatePipe } from '@angular/common';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { FunctionPublic } from './../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service'
import moment from 'moment';
@Component({
	selector: 'kt-de-nghi-chuyen-kho-history-hh-khonhap',
	templateUrl: './de-nghi-chuyen-kho-history-hh-khonhap.component.html',
	styleUrls: ['../de-nghi-chuyen-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})





export class DeNghiChuyenKhoHistoryHHKhoNhapComponent implements OnInit, OnDestroy {
	/*Config Form */
	CONFIG: CommonConFig;
	// Public properties
	DeNghiChuyenKho: DeNghiChuyenKhoModel;
	DeNghiChuyenKhoForm: FormGroup;
	DeNghiChuyenKhoCT: DeNghiChuyenKhoCTModel;
	DeNghiChuyenKhoCTForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	listPhongBanDeNghi: any[] = [];
	selectPhongBanDeNghi: string[] = [];
	filteredPhongBanDeNghi: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PhongBanDeNghiFilterCtrl: string = '';
	haveElementPhongBanDeNghi: boolean = false;
	listHangHoaId: any[] = [];
	selectHangHoaId: string[] = [];
	filteredHangHoaId: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HangHoaIdFilterCtrl: string = '';
	haveElementHangHoaId: boolean = false;
	listKhoChuyen: any[] = [];
	selectKhoChuyen: string[] = [];
	filteredKhoChuyen: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoChuyenFilterCtrl: string = '';
	haveElementKhoChuyen: boolean = false;
	listKhoNhan: any[] = [];
	selectKhoNhan: string[] = [];
	filteredKhoNhan: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoNhanFilterCtrl: string = '';
	haveElementKhoNhan: boolean = false;
	listTinhTrangCT: any[] = [];
	selectTinhTrangCT: string[] = [];
	filteredTinhTrangCT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	TinhTrangCTFilterCtrl: string = '';
	haveElementTinhTrangCT: boolean = false;
	displayedColumns: string[] = [];
	availableColumns = [
		
		{
			stt: 2,
			name: '#',
			isShow: true
		},
		// {
		// 	stt: 2,
		// 	name: 'MaHH',
		// 	isShow: true
		// },
		// {
		// 	stt: 2,
		// 	name: 'TenHH',
		// 	isShow: true
		// },
		
		{
			stt: 2,
			name: 'SoLo',
			isShow: true
		},
		{
			stt: 2,
			name: 'Soluongthucnhap',
			isShow: true
		},
		{
			stt: 2,
			name: 'TenDVT1',
			isShow: true
		},
		{
			stt: 2,
			name: 'Ngaynhapkho',
			isShow: true
		},
		{
			stt: 2,
			name: 'Sophieu',
			isShow: true
		},
		{
			stt: 2,
			name: 'Tinhtrang',
			isShow: true
		},
		{
			stt: 2,
			name: 'Tenkho',
			isShow: true
		},
		{
			stt: 2,
			name: 'ViTriKho',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoMay',
			isShow: true
		},
		{
			stt: 2,
			name: 'MaSub',
			isShow: true
		},
		
		


		
	];
	previousIndex: number;
	idcocaupb: any;
	userinfor: any = {};
	namenguoitao: string = '';
	ArrayIdNumber: number[] = [];
	private componentSubscriptions: Subscription;
	disabledAddBtn: boolean = false;
	tmpDeNghiChuyenKhoCT: DeNghiChuyenKhoCTModel[] = [];
	tmpChiTietHang:HistoryHHNhapKho[]=[];
	optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'NK_PHIEUMOI',
		},
		{
			id: 2,
			name: 'Chờ xác nhận',
			value: 'NK_CHOXACNHAN',
		},
		{
			id: 3,
			name: 'Đã hủy',
			value: 'NK_DAHUY',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'NK_HOANTAT',
		}
	];
	getdatenow: Date = new Date();
	queryParams: QueryParamsModel;

	loaiHH: any[] = [
		{

			name: "Nguyên Liệu",
			value: '1'
		},
		{

			name: "Phụ Liệu",
			value: '2'
		},
		{

			name: "Hóa Chất",
			value: '3'
		},
		{

			name: "Thành Phẩm",
			value: '4'
		},
		{

			name: "Bán Thành Phẩm",
			value: '5'
		},
		{

			name: "Bao Bì",
			value: '6'
		},
		{

			name: "Văn Phòng Phẩm",
			value: '7'
		},
		{

			name: "Vật Tư",
			value: '8'
		},
		{

			name: "Tài Sản",
			value: '9'
		},
		{

			name: "Công Cụ Dụng Cụ",
			value: '10'
		},
		{

			name: "Trang Thiết Bị",
			value: '11'
		},
		{

			name: "Phụ Gia",
			value: '12'
		},
		{

			name: "Nhiên liệu",
			value: '13'
		},
	]

	path: string = 'DNCK';


	selection = new SelectionModel<DeNghiChuyenKhoCTModel>(true, []);


	constructor(
		public dialogRef: MatDialogRef<DeNghiChuyenKhoHistoryHHKhoNhapComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private DeNghiChuyenKhoFB: FormBuilder,
		private DeNghiChuyenKhoCTFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private changeDetect: ChangeDetectorRef,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private DungChungService: DungChungService,
		private denghichuyenkhosService: DeNghiChuyenKhoService) {
		dialogRef.disableClose = true;
	}
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			// 
			if (event.key == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description) {
				this.back();
			}
			
			this.changeDetect.detectChanges();
		});
		this.tokenStorage.getFullName().subscribe(name => { this.namenguoitao = name })
		this.tokenStorage.getCoCauId().subscribe(cocau => { this.idcocaupb = cocau })
		this.tokenStorage.getUserInfo().subscribe(infor => { this.userinfor = infor });
		this.viewLoading = false;
		

		this.ListPhongBanDeNghi();
		this.ListHangHoaId();
		this.Loadcolumntable();
		this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
		this.DeNghiChuyenKho.clear();

		this.DeNghiChuyenKhoCT = new DeNghiChuyenKhoCTModel();
		this.DeNghiChuyenKhoCT.clear();

		this.createForm();
		
		if (this.data.Id > 0) {
			this.DungChungService.listHistoryHHNhapKho(this.data.Id).subscribe(res => {
				if (res.status == 1 && res.data) {
					this.tmpChiTietHang = res.data;					
					this.changeDetectorRefs.detectChanges();
				}
			});

			
		}

	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.DeNghiChuyenKhoForm = this.DeNghiChuyenKhoFB.group({
			soPhieu: [(this.DeNghiChuyenKho.SoPhieu == null || this.DeNghiChuyenKho.SoPhieu == '') ? '' : this.DeNghiChuyenKho.SoPhieu],
			ngayTao: [(this.DeNghiChuyenKho.NgayTao == null || this.DeNghiChuyenKho.NgayTao == '') ? this.FormatDatetime(this.getdatenow) : this.FormatDatetime(this.DeNghiChuyenKho.NgayTao)],
			tenNguoiTao: [(this.DeNghiChuyenKho.TenNguoiTao == null || this.DeNghiChuyenKho.TenNguoiTao == '') ? this.namenguoitao : this.DeNghiChuyenKho.TenNguoiTao],
			trangThai: [(this.DeNghiChuyenKho.TrangThai == null || this.DeNghiChuyenKho.TrangThai == '') ? this.convertTitleTinhTrang(this.optionsTinhTrang[0].value) : this.convertTitleTinhTrang(this.DeNghiChuyenKho.TrangThai)],
			phongBanDeNghi: [(this.DeNghiChuyenKho.PhongBanDeNghi == null || this.DeNghiChuyenKho.PhongBanDeNghi == 0) ? this.idcocaupb+'' : this.DeNghiChuyenKho.PhongBanDeNghi.toString(), Validators.required],
			ngayChuyen: [(this.DeNghiChuyenKho.NgayChuyen == null || this.DeNghiChuyenKho.NgayChuyen == '') ? this.getdatenow : this.DeNghiChuyenKho.NgayChuyen, Validators.required],
		});
		this.DeNghiChuyenKhoCTForm = this.DeNghiChuyenKhoCTFB.group({
			hangHoaId: ['', Validators.required],
			maHang: [''],
			tenHang: [''],
			quyCach: [''],
			tenDVT: [''],
			khoChuyen: ['', Validators.required],
			khoNhan: ['', Validators.required],
			sLTon: [(this.DeNghiChuyenKhoCT.SLTon == null || this.DeNghiChuyenKhoCT.SLTon == 0) ? '' : this.DeNghiChuyenKhoCT.SLTon],
			soLuong: [(this.DeNghiChuyenKhoCT.SoLuong == null || this.DeNghiChuyenKhoCT.SoLuong == 0) ? '' : this.DeNghiChuyenKhoCT.SoLuong, Validators.required],
			soLo: [(this.DeNghiChuyenKhoCT.SoLo == null || this.DeNghiChuyenKhoCT.SoLo == '') ? '' : this.DeNghiChuyenKhoCT.SoLo],
			soMay: [(this.DeNghiChuyenKhoCT.SoMay == null || this.DeNghiChuyenKhoCT.SoMay == '') ? '' : this.DeNghiChuyenKhoCT.SoMay],
			ghiChu: [(this.DeNghiChuyenKhoCT.GhiChu == null || this.DeNghiChuyenKhoCT.GhiChu == '') ? '' : this.DeNghiChuyenKhoCT.GhiChu],

		});

		let controls = this.DeNghiChuyenKhoForm.controls;
		let controlsCT = this.DeNghiChuyenKhoCTForm.controls;

		controls['soPhieu'].disable();
		controls['ngayTao'].disable();
		controls['tenNguoiTao'].disable();
		controls['trangThai'].disable();

		controlsCT['tenHang'].disable();
		controlsCT['quyCach'].disable();
		controlsCT['tenDVT'].disable();
		controlsCT['sLTon'].disable();

		if (this.DeNghiChuyenKho.Id == 0) {
			this.generateAutoSoPhieu();
		}

		if (this.DeNghiChuyenKho.listDeNghiChuyenKhoCT.length > 0) {
			this.DeNghiChuyenKho.listDeNghiChuyenKhoCT.forEach(element => {
				let item: DeNghiChuyenKhoCTModel;
				this.tmpDeNghiChuyenKhoCT.push(element);
			});
			this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
		}
		this.changeDetectView();
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		
			return `Lịch sử nhập kho ${this.data.MaHang} - ${this.data.TenHang}`;
		
		
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.DeNghiChuyenKhoForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(status: number) {
		this.hasFormErrors = false;
		const controls = this.DeNghiChuyenKhoForm.controls;
		/** check form */
		if (this.DeNghiChuyenKhoForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}


		if(this.tmpDeNghiChuyenKhoCT.length==0){
			const message = `Vui lòng thêm hàng.`;
			this.layoutUtilsService.showErorr(message);
			return;
		}
		
		// tslint:disable-next-line:prefer-const
		
		let editedDeNghiChuyenKho = this.prepareDeNghiChuyenKhos(status);
		if (this.DeNghiChuyenKho.Id > 0) {
			this.updateDeNghiChuyenKho(editedDeNghiChuyenKho, status)
			return;
		}
		this.addDeNghiChuyenKho(editedDeNghiChuyenKho, status);
	}
	/**
	 * Returns object for saving
	 */
	prepareDeNghiChuyenKhos(status:number): DeNghiChuyenKhoModel {
		const controls = this.DeNghiChuyenKhoForm.controls;
		const _DeNghiChuyenKho = new DeNghiChuyenKhoModel();
		_DeNghiChuyenKho.clear();
		_DeNghiChuyenKho.SoPhieu = controls['soPhieu'].value;
		_DeNghiChuyenKho.NgayTao = moment(this.getdatenow).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_DeNghiChuyenKho.TenNguoiTao = controls['tenNguoiTao'].value;
		_DeNghiChuyenKho.TrangThai = this.convertCodeTinhTrang(status);
		_DeNghiChuyenKho.PhongBanDeNghi = controls['phongBanDeNghi'].value;
		_DeNghiChuyenKho.NgayChuyen = moment(controls['ngayChuyen'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS')
		_DeNghiChuyenKho.listDeNghiChuyenKhoCT=this.tmpDeNghiChuyenKhoCT;
		//gán lại giá trị id 
		if (this.DeNghiChuyenKho.Id > 0) {
			_DeNghiChuyenKho.Id = this.DeNghiChuyenKho.Id;
		}
		return _DeNghiChuyenKho;
	}
	/**
	 * Add item
	 *
	 * @param _DeNghiChuyenKho: DeNghiChuyenKhoModel
	 * @param withBack: boolean
	 */
	addDeNghiChuyenKho(_DeNghiChuyenKho: DeNghiChuyenKhoModel, status) {
		this.disabledAddBtn = true;
		this.denghichuyenkhosService.createDeNghiChuyenKho(_DeNghiChuyenKho).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Đề nghị chuyển kho mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
				this.DeNghiChuyenKhoForm.reset();
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
				this.DeNghiChuyenKho.clear();
				this.disabledAddBtn = false;
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.DeNghiChuyenKhoForm.reset();
					this.DeNghiChuyenKho.Id = 0;
				} else {
					this.DeNghiChuyenKho.Id = res.data.Id;
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Update item
	 *
	 * @param _DeNghiChuyenKho: DeNghiChuyenKhosModel
	 * @param withBack: boolean
	 */
	updateDeNghiChuyenKho(_DeNghiChuyenKho: DeNghiChuyenKhoModel, status: number) {
		this.disabledAddBtn = true;
		this.denghichuyenkhosService.updateDeNghiChuyenKho(_DeNghiChuyenKho).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Đề nghị chuyển kho đã được cập nhập`;
				this.layoutUtilsService.showInfo(message);
				this.disabledAddBtn = false;
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
					this.DeNghiChuyenKho.clear();
					this.DeNghiChuyenKho.Id = 0;
					this.DeNghiChuyenKhoForm.reset();
				} else {
					this.DeNghiChuyenKho.Id = res.data.Id;
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ListPhongBanDeNghi() {
		this.denghichuyenkhosService.listPhongBanDeNghi().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPhongBanDeNghi = res.data;
				this.filteredPhongBanDeNghi.next(this.listPhongBanDeNghi.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterPhongBanDeNghi() {
		
		if (!this.listPhongBanDeNghi) {
			return;
		}
		// get the search keyword
		let search = this.PhongBanDeNghiFilterCtrl;
		if (!search) {
			this.filteredPhongBanDeNghi.next(this.listPhongBanDeNghi.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredPhongBanDeNghi.next(
			this.listPhongBanDeNghi.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ListHangHoaId() {
		let queryParams = new QueryParamsModel({});
		queryParams.filter.listLoaiHH = this.loaiHH.map(x => x.value);
		this.DungChungService.layDanhSachHHTheoNhieuLoai(queryParams).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listHangHoaId = res.data;
				this.filteredHangHoaId.next(this.listHangHoaId.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterHangHoaId() {
		
		if (!this.listHangHoaId) {
			return;
		}
		// get the search keyword
		let search = this.HangHoaIdFilterCtrl;
		if (!search) {
			this.filteredHangHoaId.next(this.listHangHoaId.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredHangHoaId.next(
			this.listHangHoaId.filter(ts =>
				(ts.MaHH + ' - ' + ts.TenHH).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ListKhoChuyen() {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		this.denghichuyenkhosService.listKhoChuyen(controls['hangHoaId'].value).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoChuyen = res.data;
				this.filteredKhoChuyen.next(this.listKhoChuyen.slice());

				

				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterKhoChuyen() {
		
		if (!this.listKhoChuyen) {
			return;
		}
		// get the search keyword
		let search = this.KhoChuyenFilterCtrl;
		if (!search) {
			this.filteredKhoChuyen.next(this.listKhoChuyen.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoChuyen.next(
			this.listKhoChuyen.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ListKhoNhan() {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		this.denghichuyenkhosService.listKhoNhan(controls['khoChuyen'].value).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoNhan = res.data;
				this.filteredKhoNhan.next(this.listKhoNhan.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterKhoNhan() {
		
		if (!this.listKhoNhan) {
			return;
		}
		// get the search keyword
		let search = this.KhoNhanFilterCtrl;
		if (!search) {
			this.filteredKhoNhan.next(this.listKhoNhan.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoNhan.next(
			this.listKhoNhan.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		// var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '0';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.DeNghiChuyenKhoCTForm.controls[controlName].value.replace(/,/g, "");
			this.DeNghiChuyenKhoCTForm.controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else {
			this.DeNghiChuyenKhoCTForm.controls[controlName].setValue(event.target.value);
		}
	}
	/*begin kéo thả cột */

	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.Loadcolumntable();
		}
	}
	Loadcolumntable() {
		this.displayedColumns = [];
		this.availableColumns.forEach(item => this.displayedColumns.push(item.name));
	}
	/*end kéo thả cột */
	/* formatnumber for calculate */

	FormatCommaNumber(item: string) {
		return item.replace(/,/g, "");
	}
	/*end  formatnumber for calculate*/
	/*format datetime */

	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	/*end format datetime*/
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		
		this.dialogRef.close(
			{
				IsChange: this.isChange,
				ArrayIdNumber: this.ArrayIdNumber
			});
	}
	clearSelectPhongBanDeNghi(event: any) {
		this.DeNghiChuyenKhoForm.controls["phongBanDeNghi"].setValue('');
		event.stopPropagation();
	}
	HangHoaId(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["hangHoaId"].setValue('');
		event.stopPropagation();
	}
	clearSelectKhoChuyen(event: any) {

		this.DeNghiChuyenKhoCTForm.controls["khoChuyen"].setValue('');
		event.stopPropagation();
	}
	KhoNhan(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["khoNhan"].setValue('');
		event.stopPropagation();
	}
	clearSelectTinhTrangCT(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["tinhTrangCT"].setValue('');
		event.stopPropagation();
	}
	/* format number currency */
	validationSoLuong(soluong) {
		return soluong.match('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')
	}
	//#region Kiểm tra định dạng số lượng 
	keyUpInputKhoiLuong(event) {
		FunctionPublic.preventAlpha(event);
	}
	changeInputKhoiLuong(event, columnName) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChanged(event);
			if (data) {
				this.DeNghiChuyenKhoForm.controls[columnName].setValue(data);
				this.changeDetect.detectChanges();
			}
		}
	}
	/* end */
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	convertTitleTinhTrang(code: string) {
		switch (code) {
			case this.optionsTinhTrang[0].value:

				return this.optionsTinhTrang[0].name;
			case this.optionsTinhTrang[1].value:

				return this.optionsTinhTrang[1].name;
			case this.optionsTinhTrang[2].value:

				return this.optionsTinhTrang[2].name;
			case this.optionsTinhTrang[3].value:

				return this.optionsTinhTrang[3].name;
			
			default:
				break;
		}
	}

	convertCodeTinhTrang(code: number) {
		switch (code) {
			case 0:

				return this.optionsTinhTrang[0].value;
			case 1:

				return this.optionsTinhTrang[1].value;
			case 2:
				return this.optionsTinhTrang[1].value;
			default:
				break;
		}
	}

	//get css for status
	getItemCssClassByStatus(status: string = ''): string {
		switch (status) {
			case this.optionsTinhTrang[1].value:
				return '_dangsoanthao';
			case this.optionsTinhTrang[2].value:
				return '_chotiepnhan';

			case this.optionsTinhTrang[3].value:
				return '_chokiemtra';
			case this.optionsTinhTrang[4].value:
				return '_chocapnhathuongxuly';
			case this.optionsTinhTrang[5].value:
				return '_hoantat';


		}
		return '';
	}

	addDetailDeNghiChuyenKho() {
		var constrols = this.DeNghiChuyenKhoCTForm.controls;
		
		if (this.DeNghiChuyenKhoCTForm.invalid) {
			Object.keys(constrols).forEach(controlName =>
				constrols[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			// document.getElementById('dialog-formct').scrollTo({ top: 0, behavior: 'smooth' });
			return;
		}
		var itemHH = this.listHangHoaId.filter(x => x.Id_HH == constrols['hangHoaId'].value);
		var itemKhoChuyen = this.listKhoChuyen.filter(x => x.Id_Kho == constrols['khoChuyen'].value);
		var itemKhoNhan = this.listKhoNhan.filter(x => x.Id_Kho == constrols['khoNhan'].value);
		let item = new DeNghiChuyenKhoCTModel();
		item.clear();
		

		item.HangHoaId = constrols['hangHoaId'].value;
		item.TenHang = itemHH[0].TenHH;
		item.MaHang = itemHH[0].MaHH;
		item.QuyCach = constrols['quyCach'].value;
		item.Dvt=itemHH[0].DVT1;
		item.TenDVT = constrols['tenDVT'].value;
		item.KhoChuyen = constrols['khoChuyen'].value;
		item.KhoNhan = constrols['khoNhan'].value;
		item.SLTon = constrols['sLTon'].value;
		item.SoLuong = Number(this.formatComparenumber(constrols['soLuong'].value).toString());
		item.SoLo = constrols['soLo'].value;
		item.SoMay = constrols['soMay'].value;
		item.GhiChu = constrols['ghiChu'].value;
		item.TenKhoChuyen = itemKhoChuyen[0].TenKho;
		item.TenKhoNhan = itemKhoNhan[0].TenKho;
		item.SLThucNhap=0;
		item.SLThucXuat=0;
		//item.NgayDuyet=null;
		


		this.tmpDeNghiChuyenKhoCT.push(item);
		this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];

		//reset formgroup detail
		this.DeNghiChuyenKhoCTForm.reset();


		this.changeDetectView();
	}

	getNameHH() {
		let name = '';

		if (this.listHangHoaId.length > 0) {
			var item = this.listHangHoaId.filter(x => x.Id_HH == +this.DeNghiChuyenKhoCTForm.controls['hangHoaId'].value);
			if (item.length > 0) name = item[0].MaHH;
		}
		return name ? name : '';
	}
	changeHH() {




		this.ListKhoChuyen();

		if (this.listHangHoaId.length > 0) {
			let controls = this.DeNghiChuyenKhoCTForm.controls;

			var itemHH = this.listHangHoaId.filter(x => x.Id_HH == controls['hangHoaId'].value)

			controls['tenHang'].setValue(itemHH[0].TenHH);
			controls['quyCach'].setValue(itemHH[0].QuyCachDongGoi);
			controls['tenDVT'].setValue(itemHH[0].TenDVT1);

			this.changeDetectView();
		}

	}
	changeTuKho() {




		this.ListKhoNhan();



	}

	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}

	getToTalSoLuongTon() {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		if (controls['hangHoaId'].value != '' && controls['khoChuyen'].value != '' && this.listKhoChuyen.length > 0) {
			let itemHH = this.listKhoChuyen.filter(x => x.Id_Kho == controls['khoChuyen'].value);
			controls['sLTon'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].TotalSoLuongTon+'')));
		}
	}

	generateAutoSoPhieu() {
		this.DungChungService.getBillNumber(this.path).subscribe(res => {
			if (res && res.status == 1) {
				var controls = this.DeNghiChuyenKhoForm.controls;
				controls['soPhieu'].setValue(res.data);
				
				this.changeDetectView();
			}
		})
	}

	removeDetailDeNghiChuyenKho(index){
		
		this.tmpDeNghiChuyenKhoCT.splice(index,1);
		this.tmpDeNghiChuyenKhoCT=[...this.tmpDeNghiChuyenKhoCT];
		this.changeDetectView();
	}

	loadChiTietSLTon(event){
		let controls=this.DeNghiChuyenKhoCTForm.controls;
		this.DungChungService.layChiTietHangTonKho_List(controls['hangHoaId'].value,controls['hangHoaId'].value).subscribe(res=>{
			if (res && res.status == 1) {
				
				
				this.changeDetectView();
			}
		})
	}

	/** SELECTION */
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpDeNghiChuyenKhoCT.length;
		return numSelected === numRows;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpDeNghiChuyenKhoCT.forEach(row => this.selection.select(row));
		}
		
	}

	NoiDungTrangThai(status) {
		
		switch (status) {
			case this.optionsTinhTrang[0].value:
				return this.optionsTinhTrang[0].name;
			case this.optionsTinhTrang[1].value:
				return this.optionsTinhTrang[1].name;
			case this.optionsTinhTrang[2].value:
				return this.optionsTinhTrang[2].name;
			case this.optionsTinhTrang[3].value:
				return this.optionsTinhTrang[3].name;
		
		}
		
	}

	// .. Điều chỉnh hàm format
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
}
